<template>
  <div :class="classes" :style="styles">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'VvScreenWrapper',
  computed: {
    classes() {
      const isDesktop = this.$mq === 'desktop'

      return `screen ${this.class ? this.class : ''} ${isDesktop ? 'desktop' : ''}`
    },
    styles() {
      return this.style || ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
